import { Message } from "@twilio/conversations";
import {
  ConnectionState as SyncConnectionState,
  SyncMapItem,
} from "twilio-sync";

export type ConnectionError = {
  terminal: boolean;
  message: string;
};

export type SyncMapEvent = "itemAdded" | "itemUpdated" | "itemRemoved";

export type SyncMapEventHandler = (SyncMapItem: { item: SyncMapItem }) => void;

export type MessageHandler = (message: Message) => void;

export type ConnectionStateStatus = SyncConnectionState;

// Enum for the ConnectionStateStatus i.e. ConnectionState from
// twilio-sync/conversations
export enum ConnectionState {
  CONNECTED = "connected",
  CONNECTING = "connecting",
  DISCONNECTED = "disconnected",
  DISCONNECTING = "disconnecting",
  DENIED = "denied",
  ERROR = "error",
  UNKNOWN = "unknown",
}

export enum ClientTranscriptionUserAction {
  REJECT = "reject", // Applied when user clicks to reject consent
  DISMISS = "dismiss", // Applied when user closes consent prompt without explicitly clicking reject button
}

export type Constraint =
  | ConstrainDOMString
  | ConstrainBoolean
  | ConstrainDouble
  | ConstrainULong;
